import { get, uniq, map, union } from 'lodash';
import {
  getPendingItemQuantityDiff,
  variantWithSku,
  productWithId,
  orderLineItemWithSku,
  getOrderLineItemQuantityDiff,
} from './selectors';

const itemProperties = (lineItem, state) => {
  const options = lineItem.options || [];
  const flavorOption = options.find(option => option.type_name === 'flavor');
  const variant = get(flavorOption, 'value_presentation');
  const spreeVariant = variantWithSku(lineItem.sku, state);
  const product = productWithId(spreeVariant.product_id, state);
  return {
    product_id: product.id.toString(),
    sku: lineItem.sku,
    name: product.name,
    variant: variant,
    price: parseFloat(spreeVariant.price),
    quantity: lineItem.quantity,
    image_url: spreeVariant.image_url,
  };
};

const skuQuantityDiff = (sku, orderPrev, orderNew) => {};

export const collectionAdded = collectionsPending => {
  const properties = collectionsPending;
  analytics.track('Collection Added', properties);
};

export const cartContentsChanged = (orderPrev, orderNew, state) => {
  getOrderLineItemQuantityDiff(
    orderPrev,
    orderNew,
    state
  ).forEach(({ quantityDiff, lineItemNew, lineItemPrev }) => {
    let eventName;
    if (quantityDiff === 0) {
      return;
    } else if (quantityDiff > 0) {
      eventName = 'Product Added';
    } else {
      eventName = 'Product Removed';
    }
    const properties = itemProperties(lineItemNew, state);
    properties.quantity = Math.abs(quantityDiff);
    properties.products = orderNew.line_items.map(lineItem =>
      itemProperties(lineItem, state)
    );
    analytics.track(eventName, properties);
  });
};



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/tracking.js